import { useQuery } from '@tanstack/react-query';
import { getPivotLevels, PivotLevelsResponse } from '../../../api/metrics';
import { transformPivotData } from '../utils/chartDataTransformer';
import { PivotChartDataPoint } from '../../../types/pivotPoints.ts';

/**
 * Hook to fetch pivot levels time-series data
 */
export function usePivotLevels(
  productId: string,
  timeframe: string,
  startDate: Date,
  endDate: Date,
  enabled: boolean = true
) {
  return useQuery<PivotChartDataPoint[], Error>({
    queryKey: ['pivotLevels', productId, timeframe, startDate.toISOString(), endDate.toISOString()],
    queryFn: async () => {
      const response = await getPivotLevels(
        productId,
        timeframe,
        startDate.toISOString(),
        endDate.toISOString()
      );
      return transformPivotData(response.data);
    },
    enabled: enabled && !!productId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes (renamed from cacheTime)
    refetchOnWindowFocus: false,
  });
}
